module.exports = __webpack_public_path__ + "img/fagioli-all-uccelletto.a0e94e7d.png";